import { BrowserRouter, Routes } from "react-router-dom";
import ThemeContext from "./context/ThemeContext";
import { UserContext } from "./context/UserContext";
import { LoaderProvider } from "./context/LoaderContext";
import { useEffect, useState } from "react";
import { ApplicationRoutes } from "./routes/application-routes";
import "./App.css";
import Loader from "./components/loader/loader";
import { AlertProvider } from "./context/AlertContext";
import GlobalAlert from "./components/Modals/GlobalAlertModal/GlobalAlert";
import { NotificationsProvider } from "./context/NotificationsContext";
import NotificationsPanel from "./components/NotificationsPanel/NotificationsPanel";
import { GetLocalSetting, Log, RevokeAllSessionUrls, SetLocalSetting } from "./utils/genericUtils";
import Analytics from "./components/Analytics/Analytics";

function App() {
  //const router = useNavigate();
  const [theme, setTheme] = useState("light");
  const [user, loginUser] = useState(null);

  //once per render
  useEffect(() => {
    //on page refresh remove all session urls
    window.addEventListener("load", () => {
      RevokeAllSessionUrls();
    });

    let _theme = GetLocalSetting("theme");
    if (!_theme) {
      Log("--> set theme user: ", user);
      //if local setting not present use setting found in user settings
      if (user && user.settings && user.settings.theme) {
        Log("setting theme from user settings");
        _theme = user.settings.theme;
        SetLocalSetting("theme", _theme);
        setTheme(_theme);
      }
    } else {
      Log("local theme setting found: ", _theme);
      setTheme(_theme);
    }

    updateSiteTheme();
  }, [user, theme]);

  function updateSiteTheme() {
    var r = document.querySelector(":root");
    switch (theme) {
      case "light":
        r.style.setProperty("--text-color", "black");
        r.style.setProperty("--text-color-hover", "#2c2c2c");
        r.style.setProperty("--object-text-color", "#326aac");
        r.style.setProperty("--text-alt-color-1", "#326aac");
        r.style.setProperty("--text-alt-color-2", "white");
        r.style.setProperty("--text-alt-color-3", "#326aac");
        //generic colors
        r.style.setProperty("--primary-color", "#326aac");
        r.style.setProperty("--secondary-color", "#589ce6");
        r.style.setProperty("--tertiary-color", "#2c2c2c");
        //any whites
        r.style.setProperty("--blank-color", "white");
        //specific elements
        r.style.setProperty("--profile-accent-color", "#468fe4");
        r.style.setProperty("--login-page-gradient-bg", "#1f426b");
        r.style.setProperty("--navbar-gradient-bg", "#a3b6d4");
        r.style.setProperty("--navbar-link-underline", "#2c2c2c");
        r.style.setProperty("--input-bg", "white");
        r.style.setProperty("--input-text-color", "black");
        r.style.setProperty("--button-text-color", "white");
        //other
        r.style.setProperty("--active-toggle-color", "green");
        r.style.setProperty("--inactive-toggle-color", "darkgray");
        r.style.setProperty("--info-block-bg", "#589ce6");
        break;
      case "dark":
        //set text to white
        r.style.color = "white";
        r.style.setProperty("--text-color", "white");
        r.style.setProperty("--text-color-hover", "#b9b3b3");
        r.style.setProperty("--object-text-color", "white");
        r.style.setProperty("--text-alt-color-1", "white");
        r.style.setProperty("--text-alt-color-2", "white");
        r.style.setProperty("--text-alt-color-3", "#326aac");
        //generic colors
        r.style.setProperty("--primary-color", "#202026");
        r.style.setProperty("--secondary-color", "#ffffff");
        r.style.setProperty("--tertiary-color", "#1c1c1c");
        //any darks
        r.style.setProperty("--blank-color", "#2c2c2c");
        //specific elements
        r.style.setProperty("--profile-accent-color", "#2c2c2c");
        r.style.setProperty("--login-page-gradient-bg", "#2c2c2c");
        r.style.setProperty("--navbar-gradient-bg", "#2c2c2c");
        r.style.setProperty("--navbar-link-underline", "white");
        r.style.setProperty("--input-bg", "#dddddd");
        r.style.setProperty("--input-text-color", "black");
        r.style.setProperty("--button-text-color", "white");
        //other
        r.style.setProperty("--active-toggle-color", "green");
        r.style.setProperty("--inactive-toggle-color", "darkgray");
        r.style.setProperty("--info-block-bg", "#589ce6");

        break;
    }
  }

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      <NotificationsProvider>
        <AlertProvider>
          {/* global alerts */}
          <GlobalAlert />
          <LoaderProvider>
            {/* Analytics */}
            <Analytics />
            {/* Display Loader throughout site */}
            <Loader />
            {/* Notifications Panel */}
            <NotificationsPanel />
            <UserContext.Provider value={{ user, loginUser }}>
              <BrowserRouter>
                <Routes>{ApplicationRoutes()}</Routes>
              </BrowserRouter>
            </UserContext.Provider>
          </LoaderProvider>
        </AlertProvider>
      </NotificationsProvider>
    </ThemeContext.Provider>
  );
}

export default App;
